import React, {
  FunctionComponent,
  ChangeEvent,
  useState,
  useEffect,
} from "react";
import { TextField } from "@cmsgov/ds-medicare-gov";
import { limitInputLength } from "../../helpers";

interface PhoneNumberInputProps {
  label: string | JSX.Element;
  phoneNumber: EnrollPhoneNumber | undefined;
  onChange: (phone: EnrollPhoneNumber) => void;
  name: string;
  errorMessage?: string;
  size?: "small" | "medium";
}

export interface EnrollPhoneNumber {
  areaCode: string;
  exchangeCode: string;
  lineNumber: string;
}

const PhoneNumberInput: FunctionComponent<PhoneNumberInputProps> = ({
  label,
  phoneNumber = {
    areaCode: "",
    exchangeCode: "",
    lineNumber: "",
    id: "",
  },
  onChange,
  errorMessage,
  name,
  size,
}) => {
  const [phone, setPhone] = useState(phoneNumber);

  useEffect(() => {
    onChange(phone);
  }, [phone]);

  return (
    <TextField
      errorMessage={errorMessage}
      name={`${name}-phone-number`}
      label={label}
      type="tel"
      size={size}
      fieldClassName={`ds-c-field--${name}`}
      value={`${phoneNumber.areaCode}${phoneNumber.exchangeCode}${phoneNumber.lineNumber}`}
      onChange={(event: ChangeEvent<HTMLInputElement>): void => {
        limitInputLength(name, 10);

        const { value } = event.target;
        const number = value.replace(/\D/g, "");

        const areaCode = number.substring(0, 3);
        const exchangeCode = number.substring(3, 6);
        const lineNumber = number.substring(6, 10);

        setPhone({ areaCode, exchangeCode, lineNumber });
      }}
    />
  );
};

export default PhoneNumberInput;
